import { client } from "../src/sanityClient"

export async function getBikes() {
  return client.fetch(`
    *[_type == "bike"]{
      _id,
      name,
      kms,
      type,
      category,
      prices,
      "imageUrl": image.asset->url
    }
  `)
}